import { LinearProgress } from "@mui/material";
import { type FC, lazy, Suspense } from "react";
import { Navigate, useParams } from "react-router";
import { usePermissions } from "../../../server/auth/use-permissions";
import { useFlag } from "../../../server/optimizely";
import type { UUID } from "../../../utils/uuid";
import MomentReviewPage from "./moment-review-page";

const MomentFormPage = lazy(() => import("../moment-form-page"));

export const MomentReviewRoute: FC<{ isNewsletter?: boolean }> = ({ isNewsletter }) => {
  const { id } = useParams<{ id: UUID }>();
  const [reviewExperienceEnabled, , flagLoaded] = useFlag("reviewer_role");
  const { reviewer, isLoading } = usePermissions();

  if (isLoading || !flagLoaded) return <LinearProgress />;
  if (!reviewExperienceEnabled)
    return (
      <Navigate replace to={`/moments/${id ?? ""}/${isNewsletter ? "newsletter/" : ""}details`} />
    );
  return reviewer ? (
    <MomentReviewPage isNewsletter={isNewsletter} />
  ) : (
    <Suspense fallback={<LinearProgress />}>
      {/* This route is the Review tab, the one tab that fills the viewport rather than
          scrolling the page. */}
      <MomentFormPage isNewsletter={isNewsletter} fullHeight />
    </Suspense>
  );
};
